'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hudlBase = require('hudl-base');

var _loggingUtil = require('./logging-util');

// [paul.graff@hudl.com] 2016-1-29
// Prevent GET requests from being cached on older versions of IE
var ajaxGetOptions = {
  cache: false
};

var quartiles = ['play', 'view-first-quartile', 'view-midpoint-quartile', 'view-third-quartile'];

var Services = {
  getFeedItem: function getFeedItem(feedContentId, data) {
    var requestUrl = '/api/v2/feedconsumer/feed-content/' + feedContentId;
    return _hudlBase.Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  getMiniProfile: function getMiniProfile(feedUserType, feedUserRelatedId, data) {
    var requestUrl = '/home/mini-profile/' + feedUserType + '-' + feedUserRelatedId;
    return _hudlBase.Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  getHomeTimeline: function getHomeTimeline(data) {
    return _hudlBase.Xhr.instance.get('/api/v2/feedconsumer/home-timeline', data, ajaxGetOptions);
  },
  getUserTimeline: function getUserTimeline(feedUserType, feedUserRelatedId, data) {
    var requestUrl = '/api/v2/feedconsumer/user-timeline/' + feedUserType + '-' + feedUserRelatedId;
    return _hudlBase.Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  submitFeedback: function submitFeedback(data) {
    return _hudlBase.Xhr.instance.post('/home/submit-feedback', data);
  },
  viewFollowOnboarding: function viewFollowOnboarding(data) {
    return _hudlBase.Xhr.instance.post('/home/view-follow-onboarding', data);
  },
  getInitialAttachmentsForTeam: function getInitialAttachmentsForTeam(teamId, data) {
    return _hudlBase.Xhr.instance.get('/attachment/getInitialAttachmentsForTeam/' + teamId, data);
  },
  getMoreAttachmentsForTeam: function getMoreAttachmentsForTeam(teamId, page, data) {
    var requestUrl = '/attachment/getMoreAttachmentsForTeam/' + teamId + '/page/' + page;
    return _hudlBase.Xhr.instance.get(requestUrl, data);
  },
  deleteAttachmentForTeam: function deleteAttachmentForTeam(teamId, attachmentId, data) {
    var requestUrl = '/attachment/' + attachmentId + '/teamId/' + teamId;
    return _hudlBase.Xhr.instance.delete(requestUrl, data);
  },
  getRecommendedVideos: function getRecommendedVideos(data) {
    // supported params
    var communityContentId = data.communityContentId,
        feedUserId = data.feedUserId,
        gender = data.gender,
        includeOriginContent = data.includeOriginContent,
        limit = data.limit,
        recommenderFilter = data.recommenderFilter,
        sport = data.sport,
        videoRegion = data.videoRegion,
        skip = data.skip;


    var queryString = (0, _loggingUtil.serializeQueryString)({
      communityContentId: communityContentId, feedUserId: feedUserId, gender: gender, includeOriginContent: includeOriginContent, limit: limit,
      recommenderFilter: recommenderFilter, sport: sport, videoRegion: videoRegion, skip: skip
    });

    return _hudlBase.Xhr.instance.get('/api/v3/community-videos/recommendations' + queryString);
  },
  getSuggestedAthletes: function getSuggestedAthletes(data) {
    return _hudlBase.Xhr.instance.post('/api/v2/feedconsumer/friendship/recommendations', data);
  },
  getFriendships: function getFriendships(feedUserType, feedUserRelatedId, data) {
    var requestUrl = '/feedconsumer/friendship/get-friendships/' + feedUserType + '-' + feedUserRelatedId;
    return _hudlBase.Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  isFollowing: function isFollowing(feedUserType, feedUserRelatedId, data) {
    var requestUrl = '/api/v2/feedconsumer/friendship/is-following/' + feedUserType + '-' + feedUserRelatedId;
    return _hudlBase.Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  followUser: function followUser(data) {
    return _hudlBase.Xhr.instance.post('/api/v2/feedproducer/friendship/follow-user', data);
  },
  unfollowUser: function unfollowUser(data) {
    return _hudlBase.Xhr.instance.post('/api/v2/feedproducer/friendship/unfollow-user', data);
  },
  followTeam: function followTeam(data) {
    return _hudlBase.Xhr.instance.post('/api/v2/feedproducer/friendship/follow-team', data);
  },
  unfollowTeam: function unfollowTeam(data) {
    return _hudlBase.Xhr.instance.post('/api/v2/feedproducer/friendship/unfollow-team', data);
  },
  addReaction: function addReaction(communityContentType, communityContentRelatedId, reaction, data) {
    var requestUrl = '/api/v2/feedproducer/reactions/' + (communityContentType + '-' + communityContentRelatedId + '/' + reaction);
    return _hudlBase.Xhr.instance.post(requestUrl, data);
  },
  removeReaction: function removeReaction(communityContentType, communityContentRelatedId, reaction, data) {
    var requestUrl = '/api/v2/feedproducer/reactions/' + (communityContentType + '-' + communityContentRelatedId + '/' + reaction);
    return _hudlBase.Xhr.instance.delete(requestUrl, data);
  },
  getInteractions: function getInteractions(communityContentType, communityContentRelatedId, data) {
    var requestUrl = '/api/v2/feedconsumer/interactions/' + communityContentType + '-' + communityContentRelatedId;
    return _hudlBase.Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  getCommunityContentMetadata: function getCommunityContentMetadata(communityContentType, communityContentRelatedId, data) {
    var prefix = '/api/v2/feedconsumer/community-content-metadata';
    var requestUrl = prefix + '/' + communityContentType + '-' + communityContentRelatedId;
    return _hudlBase.Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  getTaggedUsers: function getTaggedUsers(communityContentType, communityContentRelatedId, data) {
    var prefix = '/api/v2/feedconsumer/community-content-metadata';
    var requestUrl = prefix + '/' + communityContentType + '-' + communityContentRelatedId + '/tagged-users';
    return _hudlBase.Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  searchAthlete: function searchAthlete(data) {
    return _hudlBase.Xhr.instance.get('/api/v2/feedconsumer/search/athletes', data);
  },
  dismissFeedItem: function dismissFeedItem(contentId, data) {
    return _hudlBase.Xhr.instance.post('/api/v2/feedproducer/home-timeline/items/' + contentId + '/dismiss', data);
  },
  dismissProfileFeedItem: function dismissProfileFeedItem(contentId, feedUserType, feedUserRelatedId, data) {
    var requestUrl = '/api/v2/feedproducer/user-timeline/items/' + contentId + '/' + feedUserType + '-' + feedUserRelatedId + '/dismiss';
    return _hudlBase.Xhr.instance.post(requestUrl, data);
  },
  getFeedUser: function getFeedUser(feedUserType, feedUserRelatedId, data) {
    var requestUrl = '/api/v2/feedconsumer/feed-user/' + feedUserType + '-' + feedUserRelatedId;
    return _hudlBase.Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  getCurrentUserDetails: function getCurrentUserDetails(data) {
    return _hudlBase.Xhr.instance.get('/api/v2/feedconsumer/feed-user-details', data, ajaxGetOptions);
  },
  logFeedContentView: function logFeedContentView(data) {
    return _hudlBase.Xhr.instance.post('/api/v2/feedconsumer/log/feed-content/view', data);
  },
  logFeedContentClick: function logFeedContentClick(data) {
    return _hudlBase.Xhr.instance.post('/api/v2/feedconsumer/log/feed-content/click', data);
  },
  logFeedContentPlayVideo: function logFeedContentPlayVideo(data) {
    return _hudlBase.Xhr.instance.post('/api/v2/feedconsumer/log/feed-content/play-video', data);
  },
  logFeedEndPlaylist: function logFeedEndPlaylist(data) {
    return _hudlBase.Xhr.instance.post('/api/v2/feedconsumer/log/feed-end/playlist', data);
  },
  logFeedEndExchange: function logFeedEndExchange(data) {
    return _hudlBase.Xhr.instance.post('/api/v2/feedconsumer/log/feed-end/exchange', data);
  },
  logFeedEndFollow: function logFeedEndFollow(data) {
    return _hudlBase.Xhr.instance.post('/api/v2/feedconsumer/log/feed-end/follow', data);
  },
  logFeedEndExplore: function logFeedEndExplore(data) {
    return _hudlBase.Xhr.instance.post('/api/v2/feedconsumer/log/feed-end/explore', data);
  },
  logProfileClick: function logProfileClick(data) {
    return _hudlBase.Xhr.instance.post('/api/v2/feedconsumer/log/profile/click', data);
  },
  logCommunityVideoQuartile: function logCommunityVideoQuartile(quartile, communityContentId, data) {
    return _hudlBase.Xhr.instance.post('/api/v3/community-content-log/' + quartiles[quartile] + '/' + communityContentId, data);
  },
  logCommunityVideoComplete: function logCommunityVideoComplete(communityContentId, data) {
    return _hudlBase.Xhr.instance.post('/api/v3/community-content-log/view-complete/' + communityContentId, data);
  },
  logCommunityVideoStop: function logCommunityVideoStop(communityContentId, data) {
    return _hudlBase.Xhr.instance.post('/api/v3/community-content-log/stop/' + communityContentId, data);
  },
  logCommunityContentImpression: function logCommunityContentImpression(communityContentId, data) {
    return _hudlBase.Xhr.instance.post('/api/v3/community-content-log/impression/' + communityContentId, data);
  },
  logCommunityVideoRecommendationClick: function logCommunityVideoRecommendationClick(communityContentId, data) {
    return _hudlBase.Xhr.instance.post('/api/v3/community-content-log/recommendation-clicked/' + communityContentId, data);
  },
  logCommunityContentShare: function logCommunityContentShare(communityContentId, data) {
    var requestUrl = '/api/v3/community-content-log/share/' + communityContentId;
    return _hudlBase.Xhr.instance.post(requestUrl, data);
  },
  dismissBasketballClassicV2OnboardingCard: function dismissBasketballClassicV2OnboardingCard(data) {
    return _hudlBase.Xhr.instance.post('/home/dismiss-basketball-classic-v2-onboarding-card', data);
  },
  publishHighlight: function publishHighlight(highlightOwnerType, highlightOwnerId, reelId) {
    var requestUrl = '/api/v3/highlight-reels/' + highlightOwnerType + '/' + highlightOwnerId + '/' + reelId + '/publish';
    return _hudlBase.Xhr.instance.post(requestUrl, {});
  },

  routes: {
    'highlightsPresign': '/api/v2/upload-requests/presigned-url',
    'highlightsUploadCredentials': '/api/v2/upload-requests/credentials/highlight-image'
  }
};

exports.default = Services;